import { apiClient } from './apiClient'

export interface Charity {
  id: string // Guid from backend
  name: string
  registry: string
  category: string
  description?: string
  logoUrl?: string
}

export interface CreateDonationRequest {
  charityId: string // Guid as string
  campaignId?: string
  amount: number
  donorName: string
  donorEmail?: string
  donorPhone?: string
  source?: string // Source/Channel: "website", "mobile", "api", "admin", etc.
}

export interface CreateDonationResponse {
  id: string
  charityId: string
  campaignId?: string
  amount: number
  donorName: string
  donorEmail?: string
  status: string
  createdAt: string
  transactionId?: string
}

export const donationsApi = {
  async getCharities(category?: string): Promise<Charity[]> {
    const url = category ? `/Donations/charities?category=${encodeURIComponent(category)}` : '/Donations/charities'
    const response = await apiClient.get<Charity[]>(url)
    return response.data
  },

  async createDonation(request: CreateDonationRequest): Promise<CreateDonationResponse> {
    const response = await apiClient.post<CreateDonationResponse>('/Donations', request)
    return response.data
  },
}

